import { render, staticRenderFns } from "./member_upgrade_record_detail.vue?vue&type=template&id=15002aff&scoped=true"
import script from "./member_upgrade_record_detail.vue?vue&type=script&lang=js"
export * from "./member_upgrade_record_detail.vue?vue&type=script&lang=js"
import style0 from "./member_upgrade_record_detail.vue?vue&type=style&index=0&id=15002aff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15002aff",
  null
  
)

export default component.exports